module.exports = __webpack_public_path__ + "img/lamden_banner.a8b01740.png";